import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { CartItem, ItemCustomization } from "../../types";
import { nanoid } from "nanoid";

interface CartState {
  restaurantId?: string;
  items: CartItem[];
}

const initialState: CartState = {
  items: [],
};

export const cartSlice = createSlice({
  name: "cart",
  initialState,
  reducers: {
    clear(state) {
      delete state.restaurantId;
      state.items = [];
    },
    addItem(
      state,
      action: PayloadAction<{
        item: ItemCustomization;
        restaurantId: string;
        totalPrice: number;
      }>
    ) {
      const { item, restaurantId, totalPrice } = action.payload;
      const cartItem = { ...item, totalPrice, displayId: nanoid(6) };
      const stateRestaurantId = state.restaurantId;
      if (!stateRestaurantId || stateRestaurantId !== restaurantId) {
        state.restaurantId = restaurantId;
        state.items = [cartItem];
      } else {
        state.items = [...state.items, cartItem];
      }
    },
    removeItem(state, action: PayloadAction<{ displayId: string }>) {
      state.items = state.items.filter(
        (item) => item.displayId !== action.payload.displayId
      );
    },
    addItemQty(state, action: PayloadAction<{ displayId: string }>) {
      const item = state.items.find(
        (item) => item.displayId === action.payload.displayId
      );
      if (item) {
        item.qty += 1;
      }
    },
    reduceItemQty(state, action: PayloadAction<{ displayId: string }>) {
      const item = state.items.find(
        (item) => item.displayId === action.payload.displayId
      );
      if (item && item.qty > 1) {
        item.qty -= 1;
      }
    },
  },
});

export const cartReducer = persistReducer(
  {
    key: "rkt:cart",
    storage,
    whitelist: ["restaurantId", "items"],
  },
  cartSlice.reducer
);

export const { clear, addItem, removeItem, reduceItemQty, addItemQty } =
  cartSlice.actions;
